import Vue from 'vue';
//import VueRouter from 'vue-router';
import store from "@/store";
import App from './App.vue';

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main';

//Bootstrap
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

// router setup
//import routes from './routes/routes';
import router from "@/router"; // ou "@/router/index.js"

import './registerServiceWorker';

//import Vuetify from 'vuetify'
//import vuetify from '@/plugins/vuetify'
//import DaySpanVuetify from 'dayspan-vuetify'
import vSelect from 'vue-select';
//import modal from "vue-js-modal"

import VueMask from 'v-mask';
Vue.use(VueMask)

import PortalVue from 'portal-vue';
Vue.use(PortalVue)

import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);

Vue.config.productionTip = false

// plugin setup
//Vue.use(VueRouter)

//Vue.use(modal, { dialog: true, dynamic: true });

Vue.use(LightBootstrap)

//Bootstrap
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
// This imports all the layout components such as <b-container>, <b-row>, <b-col>:
import { LayoutPlugin } from 'bootstrap-vue';
Vue.use(LayoutPlugin)

// This imports <b-modal> as well as the v-b-modal directive as a plugin:
import { ModalPlugin } from 'bootstrap-vue';
Vue.use(ModalPlugin)

// This imports <b-card> along with all the <b-card-*> sub-components as a plugin:
import { CardPlugin } from 'bootstrap-vue';
Vue.use(CardPlugin)

// This imports directive v-b-scrollspy as a plugin:
import { VBScrollspyPlugin } from 'bootstrap-vue';
Vue.use(VBScrollspyPlugin)

// This imports the dropdown and table plugins
import { DropdownPlugin, TablePlugin } from 'bootstrap-vue';
Vue.use(DropdownPlugin)
Vue.use(TablePlugin)

import money from 'v-money';
Vue.use(money, { precision: 2, decimal: ',', prefix: 'R$', thousands: '.' })

Vue.component('v-select', vSelect)

Vue.component('auto-logout', require('./components/AutoLogout.vue').default);

//import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css';
//import 'dayspan-vuetify/dist/lib/dayspan-vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import jwt_decode from "jwt-decode";
import 'vue-select/dist/vue-select.css';


function readToken() {
  const raw = localStorage.getItem("authorization");
  if (!raw || raw === "null" || raw === "") return null;

  // você salva com JSON.stringify, então normalmente isso resolve
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || parsed === "null") return null;
    return parsed; // token limpo sem aspas
  } catch (e) {
    // caso algum dia você salve sem stringify
    return raw;
  }
}

router.beforeEach((to, from, next) => {
  const token = readToken();

  // rota liberada (LOGOFF)?
  const isLogoff =
    to.meta && to.meta.permissions && to.meta.permissions.includes("LOGOFF");

  // 1) Sem token
  if (!token) {

    if (isLogoff) return next();

    return next({
      path: "/login/acesso",
      query: { redirect: to.fullPath }
    });
  }
  // 2) Com token: valida expiração
  let decoded;
  try {
    decoded = jwt_decode(token);
  } catch (e) {
    store.dispatch("auth/logout"); // centraliza e limpa tudo (token + dadosUsuario + loggedIn)
    if (isLogoff) return next();
    //return next({ path: "/login/acesso", query: { redirect: to.fullPath, reason: "invalid" } });
    return next({ name: "SessaoExpirada" });
  }

  if (decoded && decoded.exp && Date.now() >= decoded.exp * 1000) {
    store.dispatch("auth/logout"); // centraliza e limpa tudo (token + dadosUsuario + loggedIn)
    if (isLogoff) return next();
    //return next({ path: "/login/acesso", query: { redirect: to.fullPath, reason: "expired" } });
    return next({ name: "SessaoExpirada" });
  }

  // 3) Permissões
  if (to.meta && to.meta.permissions && to.meta.permissions.length > 0) {

    // ✅ se tiver LOGOFF, libera e não checa permissões
    if (to.meta.permissions.includes("LOGOFF")) {
      return next();
    }

    // se for LOGOFF, já liberou acima, então aqui só sobram permissões reais
    let isAllowed = false;
    to.meta.permissions.forEach((value) => {
      isAllowed = isAllowed || store.getters["auth/hasAccess"](value);
    });

    if (!isAllowed) return next("/admin/denied");
  }

  return next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})

//Vue.use(Vuetify);

/*Vue.use(DaySpanVuetify, {
  methods: {
    getDefaultEventColor: () => '#1976d2'
  }
});*/

Vue.config.productionTip = false;